import { PropsWithChildren, createContext, useContext } from "react";
import { useIntercom as useIntercomOriginal } from "react-use-intercom";

export const SafeIntercomContext = createContext<Partial<
  ReturnType<typeof useIntercomOriginal>
> | null>(null);

export function IntercomConsumer({ children }: PropsWithChildren) {
  const intercom = useIntercomOriginal();

  return (
    <SafeIntercomContext.Provider value={intercom}>
      {children}
    </SafeIntercomContext.Provider>
  );
}

export function useIntercom() {
  const ctx = useContext(SafeIntercomContext);
  return ctx ?? {};
}
